import {env} from '../../../config/env';

/**
 * Parses a pebbleplot JSON string and returns the parsed object.
 * Handles JSON with comments by removing them first.
 * This is the main utility function for processing pebbleplot code blocks.
 *
 * @param jsonString - The JSON string to parse (may contain comments)
 * @returns The parsed JSON object or null if parsing fails
 */
export function parsePebblePlotJson(jsonString: string): unknown {
  try {
    // Remove single-line comments (// ...)
    let cleaned = jsonString.replace(/\/\/.*$/gm, '');
    // Remove multi-line comments (/* ... */)
    cleaned = cleaned.replace(/\/\*[\s\S]*?\*\//g, '');
    // Parse the cleaned JSON
    return JSON.parse(cleaned);
  } catch (error) {
    if (env.isDev) {
      console.error('Failed to parse pebbleplot JSON:', {
        error,
        errorMessage: error instanceof Error ? error.message : String(error),
        jsonString,
        jsonStringLength: jsonString?.length,
        jsonStringPreview: jsonString?.substring(0, 500),
      });
    }
    return null;
  }
}
